import { render, staticRenderFns } from "./ShareDetail.vue?vue&type=template&id=f223eb52&scoped=true"
import script from "./ShareDetail.vue?vue&type=script&lang=js"
export * from "./ShareDetail.vue?vue&type=script&lang=js"
import style0 from "./ShareDetail.vue?vue&type=style&index=0&id=f223eb52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223eb52",
  null
  
)

export default component.exports